/* eslint-disable react/prop-types */
import React, { createContext, useState, useContext, useEffect } from "react";
import { getLoggedinUser } from "../helpers/api_helper";

export const OfficeContext = createContext({});

function OfficeProvider({ children }) {
  const [office, setOffice] = useState(null);
  const [officeLoading, setOfficeLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const officeStorageKey = "@prosmed:office";
  const offices = getLoggedinUser();

  async function selectOffice(id) {
    setOfficeLoading(true);

    const office = (getLoggedinUser().data.offices || []).find(
      (office) => office.office_id === id
    );

    localStorage.setItem(officeStorageKey, JSON.stringify(office));
    setIsOpen(!isOpen);
    setOffice(office);
    window.location.reload();
  }

  const resetOffice = () => {
    localStorage.removeItem(officeStorageKey);
    setIsOpen(true);
    setOffice(null);
  };

  useEffect(() => {
    // verify if office is in sessionStorage
    const response = localStorage.getItem(officeStorageKey);

    if (response) {
      setOffice(JSON.parse(response));
    } else {
      setOffice(null);
    }
  }, []);

  useEffect(() => {
    if (offices) {
      if (offices.data.offices.length === 1) {
        setOffice(offices.data.offices[0]);
        localStorage.setItem(
          officeStorageKey,
          JSON.stringify(offices.data.offices[0])
        );
      }
    }
  }, []);

  return (
    <OfficeContext.Provider
      value={{
        office,
        officeLoading,
        selectOffice,
        resetOffice,
        isOpen,
      }}
    >
      {children}
    </OfficeContext.Provider>
  );
}

function useOffice() {
  const context = useContext(OfficeContext);

  return context;
}

export { OfficeProvider, useOffice };
